import { render, staticRenderFns } from "./Jobs.vue?vue&type=template&id=bd0bccc0"
import script from "./Jobs.vue?vue&type=script&lang=js"
export * from "./Jobs.vue?vue&type=script&lang=js"
import style0 from "./Jobs.vue?vue&type=style&index=0&id=bd0bccc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports